import { useEffect } from 'react';
import ReactGA from 'react-ga4';

const useTimeTracking = () => {
  useEffect(() => {
    const start = Date.now();

    const handleBeforeUnload = () => {
      const duration = Math.round((Date.now() - start) / 1000); // in seconds
      ReactGA.event({
        category: 'Engagement',
        action: 'Time on Page',
        value: duration,
      });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
};

export default useTimeTracking;
